import * as React from 'react';
import { Divider, Fab, Typography, Box, List, ListItem, Backdrop, Slide ,useTheme} from '@mui/material';
import { AppBarTextColor } from 'utils/ui-constants/UIConst';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useNavigate } from 'react-router';
import { makeStyles } from '@mui/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import InsightsSharpIcon from '@mui/icons-material/InsightsSharp';
import ViewCarouselSharpIcon from '@mui/icons-material/ViewCarouselSharp';
import ViewDaySharpIcon from '@mui/icons-material/ViewDaySharp';
import DocumentScannerSharpIcon from '@mui/icons-material/DocumentScannerSharp';
import { IconSettings, IconAdjustmentsAlt, IconChartDots2, IconUsers, IconUser, IconBuilding } from '@tabler/icons-react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    animation: `$fadeIn 500ms ${theme.transitions.easing.easeInOut}`, // Use MUI's theme for easing
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}));

export default function HiredrateSettingDropDown({
  keyName,
  selectMenu,
  selectTrigger,
}) {
  // const [open, setOpen] = React.useState(false);
  // const navigate = useNavigate();
  // const classes = useStyles();
  // const handleClose = () => {
  //   setOpen(false);
  // };
  // const handleOpen = () => {
  //   setOpen(true);
  // };
  const theme=useTheme();
  const [open, setOpen] = React.useState(false);
  const [isMouseOver, setIsMouseOver] = React.useState(false);
  const {token} = useSelector((state)=>state.account)
  const profileLoadType = 'sg'
  const user_info = useSelector((state)=>state.account.userData)
  // console.log('statedata user_info233',user_info);
  const navigate = useNavigate();
  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
    setIsMouseOver(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setIsMouseOver(true);
  };

  const handleNavigate = (index) => {
    // console.log(index);
    selectTrigger(index)
    if (index == 0) {
      navigate('/settings/'+profileLoadType+'/user-profile/'+token)
    } else if (index == 1) {
      navigate('/settings/user-settings')
    } else if (index == 2) {
      navigate('/jp/job-positions-listing')
    } else if (index == 3) {
      navigate('/jp/job-applications-listing')
    } else if (index == 4) {
      navigate('/jp/job-application')
    }
  }

  const handleDropdownItemClick = (val) => {
    if (val == 'My Account') {
      handleNavigate(0)
    }
    if (val == 'Users') {
      handleNavigate(1)
    }
    // else if(val == 'Companies'){
    //   handleNavigate(12)
    // }
  }

  const iconArray = [
    <IconUser />,
    <IconAdjustmentsAlt />,
    <ViewCarouselSharpIcon />,
    <ViewDaySharpIcon />,
    <DocumentScannerSharpIcon />
    // Add more icons as needed
  ];

  const list = (anchor) => (
    // <Slide in={open} direction="down" timeout={{ enter: 200, exit: 300 }}>
    user_info != null && user_info != undefined ?
    <Box
      className={classes.backdrop}
      sx={{
        margin: 0,
        width: 1200,
        backgroundColor: 'white',
        marginTop:  (user_info.role_name == null || user_info.role_name == 'Org Admin' ?-73:-79.5),
      }}
      role="presentation" 
    >
      {['App Settings', 'Job Positions Grid', 'Job Application Grid', 'Applications'].map(
        (text, index) => (
          <List key={text}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => (text !== 'App Settings' ? handleNavigate(index) : null)}
                sx={{
                  '&:hover': {
                    backgroundColor: text === 'App Settings' ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <ListItemIcon>{iconArray[index % iconArray.length]}</ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: text === 'App Settings' ? 'bold' : 'inherit',
                        cursor: text === 'App Settings' ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {text}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            {text === 'App Settings' && (
              <>
                <ListItemButton onClick={() => handleDropdownItemClick('My Account')}>
                  <ListItemIcon sx={{ ml: 4 }}><IconUsers style={{ fontSize: 1 }} /></ListItemIcon>
                  <ListItemText primary={<Typography variant="body1">My Account</Typography>} />
                </ListItemButton>
                {user_info != null && user_info != undefined  ?
                user_info.role_name == null || user_info.role_name == 'Org Admin' || user_info.role_name =='Recruiter Manager'?
                <ListItemButton onClick={() => handleDropdownItemClick('Users')}>
                  <ListItemIcon sx={{ ml: 4 }}><IconUsers style={{ fontSize: 1 }} /></ListItemIcon>
                  <ListItemText primary={<Typography variant="body1">Users</Typography>} />
                </ListItemButton>:null
                :null}
              </>
            )}
            <Divider />
          </List>
        )
      )}
    </Box>:null


    // </Slide>
  );

  return (
    <div>
      <React.Fragment key={"top"}>
        <Fab
          variant="extended"
          size="small"
          sx={{
            backgroundColor: isMouseOver ? '#e0e0e0' : 'transparent',
            // backgroundColor: "transparent",
            boxShadow: "none",
            my: 1,
            color: theme.palette.common.black,
            display: "block",
            ml: 1,
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
          key={keyName}
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
        >
          {selectMenu === keyName ? (
            <Typography
              color={AppBarTextColor}
              textAlign="center"
              variant="h5"
              fontWeight={"bold"}
              sx={{
                // paddingBottom: page === 'Dashboard' ? '8px' : '0', // Adjust the padding value as needed
                display: "flex",
                alignItems: "center", // Align the icon and text vertically
                height: "100%", // Ensure the Fab has full height
              }}
            >
              <IconSettings stroke={1.5} sx={{ fontSize: 22, mr: .5 }} />
              {keyName}
            </Typography>
          ) : (
            <Typography textAlign="center" variant="h5" fontWeight={'bold'}
              sx={{
                // paddingBottom: page === 'Dashboard' ? '8px' : '0', // Adjust the padding value as needed
                display: 'flex',
                alignItems: 'center', // Align the icon and text vertically
                height: '100%', // Ensure the Fab has full height
              }}
            >
              {/* <SettingsIcon  sx={{ fontSize: 22, mr: .5 }}/> */}
              <IconSettings stroke={1.5} sx={{ fontSize: 32, mr: 1 }} />

              {keyName}
            </Typography>
          )}
        </Fab>
      </React.Fragment>
      <Backdrop
        sx={{
          //   color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          marginTop: "70px", // Add a marginTop of 10px
        }}
        open={open}
        onClick={handleClose}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        {list("top")}
      </Backdrop>
    </div>
  );
}
